import React from 'react';
import { X } from 'lucide-react';

interface SideMenuProps {
  isOpen: boolean;
  onClose: () => void;
  onNavigate: (path: string) => void;
}

export const SideMenu: React.FC<SideMenuProps> = ({ isOpen, onClose, onNavigate }) => {
  return (
    <>
      {isOpen && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={onClose}
        />
      )}
      
      <div 
        className={`fixed top-0 left-0 h-full w-64 bg-white shadow-lg z-50 transform transition-transform duration-300 ease-in-out ${
          isOpen ? 'translate-x-0' : '-translate-x-full'
        } overflow-y-auto`}
      >
        <div className="flex justify-between items-center p-4 bg-black text-white">
          <h2 className="text-xl font-bold">Menu</h2>
          <button 
            onClick={onClose}
            className="p-1 rounded-md hover:bg-gray-800 transition duration-200"
            aria-label="Close menu"
          >
            <X size={24} />
          </button>
        </div>
        
        <nav className="p-4">
          <ul className="space-y-2">
            <li>
              <button 
                onClick={() => onNavigate('/')}
                className="w-full text-left py-2 px-4 hover:bg-red-100 rounded-md transition duration-200"
              >
                Chinese Food Near Me
              </button>
            </li>
            <li>
              <button 
                onClick={() => onNavigate('/history')}
                className="w-full text-left py-2 px-4 hover:bg-red-100 rounded-md transition duration-200"
              >
                History of Chinese Food
              </button>
            </li>
            <li>
              <button 
                onClick={() => onNavigate('/chinese-food-facts')}
                className="w-full text-left py-2 px-4 hover:bg-red-100 rounded-md transition duration-200"
              >
                Chinese Food Facts
              </button>
            </li>
            <li className="pt-2">
              <div className="text-sm font-semibold text-gray-500 px-4 py-2">
                Popular Recipes
              </div>
              <ul className="pl-4 space-y-2">
                <li>
                  <button 
                    onClick={() => onNavigate('/recipes/kung-pao-chicken')}
                    className="w-full text-left py-2 px-4 hover:bg-red-100 rounded-md transition duration-200"
                  >
                    Kung Pao Chicken
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => onNavigate('/recipes/mapo-tofu')}
                    className="w-full text-left py-2 px-4 hover:bg-red-100 rounded-md transition duration-200"
                  >
                    Mapo Tofu
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => onNavigate('/recipes/chow-mein')}
                    className="w-full text-left py-2 px-4 hover:bg-red-100 rounded-md transition duration-200"
                  >
                    Chow Mein
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => onNavigate('/recipes/hot-pot')}
                    className="w-full text-left py-2 px-4 hover:bg-red-100 rounded-md transition duration-200"
                  >
                    Hot Pot
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => onNavigate('/recipes/fried-rice')}
                    className="w-full text-left py-2 px-4 hover:bg-red-100 rounded-md transition duration-200"
                  >
                    Fried Rice
                  </button>
                </li>
                <li>
                  <button 
                    onClick={() => onNavigate('/recipes/dim-sum')}
                    className="w-full text-left py-2 px-4 hover:bg-red-100 rounded-md transition duration-200"
                  >
                    Dim Sum
                  </button>
                </li>
              </ul>
            </li>
            <li>
              <button 
                onClick={() => onNavigate('/about')}
                className="w-full text-left py-2 px-4 hover:bg-red-100 rounded-md transition duration-200"
              >
                About Us
              </button>
            </li>
            <li>
              <button 
                onClick={() => onNavigate('/faq')}
                className="w-full text-left py-2 px-4 hover:bg-red-100 rounded-md transition duration-200"
              >
                FAQ
              </button>
            </li>
            <li>
              <button 
                onClick={() => onNavigate('/contact')}
                className="w-full text-left py-2 px-4 hover:bg-red-100 rounded-md transition duration-200"
              >
                Contact Us
              </button>
            </li>
          </ul>
        </nav>
      </div>
    </>
  );
};